<template><div><h1 id="ereignisauswertung-nach-tagen" tabindex="-1"><a class="header-anchor" href="#ereignisauswertung-nach-tagen"><span>Ereignisauswertung nach Tagen</span></a></h1>
<p>Ereignisauswertung nach Tagen — Listet Responses mit Wert und Anzahl pro Tag aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Datei mit Anzahl und Wert der ausgewerteten Ereignisse, kumuliert nach Tagen. Die Datei enthält 3 Spalten, getrennt mit Tabulator.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Ereignisauswertung nach Tagen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Datum</dt>
<dd>Einschränkung der Response-Ereignisse nach Datum (inklusive).</dd>
<dt>Ereignisse</dt>
<dd>Auswahl der auszuwertenden Ereignisse. Mit Kommas trennen, ohne Leerzeichen, * = alle.</dd>
<dt>Ereignissituationen</dt>
<dd>Auswahl der auszuwertenden Ereignisse anhand der Situation. Mit Kommas trennen, ohne Leerzeichen, * = alle.</dd>
<dt>Ausgabe</dt>
<dd>Tabulator-getrennte Textdatei</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Datum</td>
<td>Jedes Datum kommt nur einmal vor, alle Responses von diesem Datum werden kumuliert.</td>
</tr>
<tr>
<td>Wert/Tag</td>
<td>Spendenwert bzw. fakturierter Auftragswert, kumuliert pro Tag</td>
</tr>
<tr>
<td>Anzahl/Tag</td>
<td>Anzahl Zahlungseingänge bzw. Fakturen, kumuliert pro Tag</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">01.09.98	390	8   01.09.98-28.10.98 Ereignisse: 1061 Ereignissituation(en): \*</span>
<span class="line">02.09.98	490	11</span>
<span class="line">03.09.98	1345	22</span>
<span class="line">04.09.98	470	10</span>
<span class="line">07.09.98	240	5</span>
<span class="line">08.09.98	405	9</span>
<span class="line">09.09.98	455	13</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line">Am 3.9.98 wurden auf das Ereignis 1061 1'345 Franken aus 22 Response-Ereignissen verzeichnet.</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


